
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class JungleVinesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, height } = pc;
        const spacing = (100 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = (3 / layerIndex) * scale;

        for (let x = x1; x <= x2; x += spacing) {
            const h = height * 1.5;
            const sway = Math.sin(time * 0.5 * config.parallaxSpeed + x) * 40 * scale;
            
            const draw = () => {
                ctx.beginPath();
                ctx.moveTo(x, -height);
                ctx.bezierCurveTo(x + sway, -height * 0.5, x - sway, height * 0.5, x, height);
                ctx.stroke();
                
                // Leaves on vine
                const leaves = Math.floor(10 * (config.parallaxComplexity || 1.0));
                ctx.fillStyle = pc.color;
                for (let i = 0; i < leaves; i++) {
                    const t = i / leaves;
                    const lx = x + Math.sin(t * Math.PI) * sway * (t > 0.5 ? -1 : 1);
                    const ly = -height + t * h;
                    ctx.save();
                    ctx.translate(lx, ly);
                    ctx.rotate(sway * 0.01 + i);
                    ctx.beginPath();
                    ctx.ellipse(0, 0, 10 * scale, 4 * scale, 0, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.restore();
                }
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
